import { ContextSelector, useContextSelector } from '@fluentui/react-context-selector';
import { ICardContext } from '../../types';
import { CardContext } from '../contexts';

export const useCardContext = <T>(selector: ContextSelector<ICardContext, T>) =>
  useContextSelector(CardContext, selector);

export const useCardContextValue = <K extends keyof ICardContext>(key: K): ICardContext[K] =>
  useContextSelector(CardContext, (ctx) => ctx[key]);
